// extracted by mini-css-extract-plugin
export default {"linkPath":"Custom_linkPath__KLDFy","content":"Custom_content__2d4-w"};